//GET_LIST_ERROR_INVOICES
export const GET_LIST_ERROR_INVOICES = "GET_LIST_ERROR_INVOICES";
export const GET_LIST_ERROR_INVOICES_SUCCESS =
  "GET_LIST_ERROR_INVOICES_SUCCESS";
export const GET_LIST_ERROR_INVOICES_FAIL = "GET_LIST_ERROR_INVOICES_FAIL";
export const RESET_LIST_ERROR_INVOICES = "RESET_LIST_ERROR_INVOICES";
//
export const SET_COLUMN_VISIBLE_ERROR_INVOICES =
  "SET_COLUMN_VISIBLE_ERROR_INVOICES";

// ERROR_INVOICES_DETAIL
export const ERROR_INVOICES_DETAIL = "ERROR_INVOICES_DETAIL";
export const ERROR_INVOICES_DETAIL_SUCCESS = "ERROR_INVOICES_DETAIL_SUCCESS";
export const ERROR_INVOICES_DETAIL_FAIL = "ERROR_INVOICES_DETAIL_FAIL";
export const ERROR_INVOICES_DETAIL_RESET = "ERROR_INVOICES_DETAIL_RESET";

// DOWNLOAD_XML_ERROR_INVOICES
export const DOWNLOAD_XML_ERROR_INVOICES = "DOWNLOAD_XML_ERROR_INVOICES";
export const DOWNLOAD_XML_ERROR_INVOICES_SUCCESS =
  "DOWNLOAD_XML_ERROR_INVOICES_SUCCESS";
export const DOWNLOAD_XML_ERROR_INVOICES_FAIL =
  "DOWNLOAD_XML_ERROR_INVOICES_FAIL";
export const RESET_DOWNLOAD_XML_ERROR_INVOICES =
  "RESET_DOWNLOAD_XML_ERROR_INVOICES";

// ERROR INVOICES CREATE
export const ERROR_INVOICES_CREATE = "ERROR_INVOICES_CREATE";
export const ERROR_INVOICES_CREATE_SUCCESS = "ERROR_INVOICES_CREATE_SUCCESS";
export const ERROR_INVOICES_CREATE_FAIL = "ERROR_INVOICES_CREATE_FAIL";
export const ERROR_INVOICES_CREATE_RESET = "ERROR_INVOICES_CREATE_RESET";

// ERROR INVOICES EDIT
export const ERROR_INVOICES_EDIT = "ERROR_INVOICES_EDIT";
export const ERROR_INVOICES_EDIT_SUCCESS = "ERROR_INVOICES_EDIT_SUCCESS";
export const ERROR_INVOICES_EDIT_FAIL = "ERROR_INVOICES_EDIT_FAIL";
export const ERROR_INVOICES_EDIT_RESET = "ERROR_INVOICES_EDIT_RESET";

// ERROR INVOICES RELEASE
export const ERROR_INVOICES_RELEASE = "ERROR_INVOICES_RELEASE";
export const ERROR_INVOICES_RELEASE_SUCCESS = "ERROR_INVOICES_RELEASE_SUCCESS";
export const ERROR_INVOICES_RELEASE_FAIL = "ERROR_INVOICES_RELEASE_FAIL";
export const ERROR_INVOICES_RELEASE_RESET = "ERROR_INVOICES_RELEASE_RESET";

// ERROR INVOICES DELETE
export const ERROR_INVOICES_DELETE = "ERROR_INVOICES_DELETE";
export const ERROR_INVOICES_DELETE_SUCCESS = "ERROR_INVOICES_DELETE_SUCCESS";
export const ERROR_INVOICES_DELETE_FAIL = "ERROR_INVOICES_DELETE_FAIL";
export const ERROR_INVOICES_DELETE_RESET = "ERROR_INVOICES_DELETE_RESET";

//TRANSFER_USB_ERROR_INVOICES
export const TRANSFER_USB_ERROR_INVOICES = "TRANSFER_USB_ERROR_INVOICES";
export const TRANSFER_USB_ERROR_INVOICES_SUCCESS =
  "TRANSFER_USB_ERROR_INVOICES_SUCCESS";
export const TRANSFER_USB_ERROR_INVOICES_FAIL =
  "TRANSFER_USB_ERROR_INVOICES_FAIL";
export const RESET_TRANSFER_USB_ERROR_INVOICES =
  "RESET_TRANSFER_USB_ERROR_INVOICES";

// ERROR INVOICES SEARCH INVOICE
export const ERROR_INVOICES_SEARCH_INVOICE = "ERROR_INVOICES_SEARCH_INVOICE";
export const ERROR_INVOICES_SEARCH_INVOICE_SUCCESS =
  "ERROR_INVOICES_SEARCH_INVOICE_SUCCESS";
export const ERROR_INVOICES_SEARCH_INVOICE_FAIL =
  "ERROR_INVOICES_SEARCH_INVOICE_FAIL";
export const ERROR_INVOICES_SEARCH_INVOICE_RESET =
  "ERROR_INVOICES_SEARCH_INVOICE_RESET";

// ERROR INVOICES TYPE INVOICE LIST
export const ERROR_INVOICES_TYPE_INVOICE_LIST =
  "ERROR_INVOICES_TYPE_INVOICE_LIST";
export const ERROR_INVOICES_TYPE_INVOICE_LIST_SUCCESS =
  "ERROR_INVOICES_TYPE_INVOICE_LIST_SUCCESS";
export const ERROR_INVOICES_TYPE_INVOICE_LIST_FAIL =
  "ERROR_INVOICES_TYPE_INVOICE_LIST_FAIL";
export const ERROR_INVOICES_TYPE_INVOICE_LIST_RESET =
  "ERROR_INVOICES_TYPE_INVOICE_LIST_RESET";

// ERROR INVOICES NOTIFICATION PROPERTIES LIST
export const ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST =
  "ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST";
export const ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_SUCCESS =
  "ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_SUCCESS";
export const ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_FAIL =
  "ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_FAIL";
export const ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_RESET =
  "ERROR_INVOICES_NOTIFICATION_PROPERTIES_LIST_RESET";

// PREVIEW_PDF_ERROR_INVOICE
export const PREVIEW_PDF_ERROR_INVOICE = "PREVIEW_PDF_ERROR_INVOICE";
export const PREVIEW_PDF_ERROR_INVOICE_SUCCESS =
  "PREVIEW_PDF_ERROR_INVOICE_SUCCESS";
export const PREVIEW_PDF_ERROR_INVOICE_FAIL = "PREVIEW_PDF_ERROR_INVOICE_FAIL";
export const RESET_PREVIEW_PDF_ERROR_INVOICE =
  "RESET_PREVIEW_PDF_ERROR_INVOICE";

// GET_HISTORY_ERROR_ENVOICE_TRANSFER
export const GET_HISTORY_ERROR_ENVOICE_TRANSFER =
  "GET_HISTORY_ERROR_ENVOICE_TRANSFER";
export const GET_HISTORY_ERROR_ENVOICE_TRANSFER_SUCCESS =
  "GET_HISTORY_ERROR_ENVOICE_TRANSFER_SUCCESS";
export const GET_HISTORY_ERROR_ENVOICE_TRANSFER_FAIL =
  "GET_HISTORY_ERROR_ENVOICE_TRANSFER_FAIL";
export const RESET_GET_HISTORY_ERROR_ENVOICE_TRANSFER =
  "RESET_GET_HISTORY_ERROR_ENVOICE_TRANSFER";
